var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.298,
    height: 22.298,
    viewBox: "0 0 22.298 22.298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3790",
    "data-name": "Group 3790",
    transform: "translate(20956.75 3986.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6023",
    "data-name": "Path 6023",
    d: "M10.342,0A10.4,10.4,0,1,0,20.8,10.342,10.4,10.4,0,0,0,10.342,0",
    transform: "translate(-20956 -3986)",
    fill: "none",
    stroke: "#5b788f",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6024",
    "data-name": "Path 6024",
    d: "M9.209,8.539a6.284,6.284,0,0,1,1.774-1.005,5.548,5.548,0,0,1,1.929-.362,4.611,4.611,0,0,1,1.395.208,3.392,3.392,0,0,1,1.15.6,2.931,2.931,0,0,1,.775.959,2.809,2.809,0,0,1,.285,1.283,2.851,2.851,0,0,1-.608,1.8,5.041,5.041,0,0,1-1.9,1.381l-.9.423-.286,1.737h-.928l-.171-1.039c-.022-.16-.041-.31-.057-.445a2.881,2.881,0,0,1-.025-.32.722.722,0,0,1,.11-.436,1.718,1.718,0,0,1,.46-.354l.562-.323c.357-.205.672-.393.943-.561a3.772,3.772,0,0,0,.676-.522,1.841,1.841,0,0,0,.4-.579,1.816,1.816,0,0,0,.13-.715,1.535,1.535,0,0,0-.589-1.307,2.416,2.416,0,0,0-1.494-.445,4.168,4.168,0,0,0-.964.116,10.326,10.326,0,0,0-1.233.408L9.689,9.4Zm2.352,9.847v-1.48h1.261a.437.437,0,0,1,.269.057.261.261,0,0,1,.065.205v1.218Z",
    transform: "translate(-20958.465 -3988.38)",
    fill: "#5b788f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1764",
    "data-name": "Rectangle 1764",
    width: 20.798,
    height: 20.798,
    transform: "translate(-20956 -3986)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon_help.ed5b867f1ba2b1fe153951bfd651feb3.svg";
export { ForwardRef as ReactComponent };